type AuthFetch = (url: string, init?: RequestInit) => Promise<Response>

function base64Bytes(value: string): Uint8Array {
  const padding = '='.repeat((4 - value.length % 4) % 4)
  const raw = atob((value + padding).replace(/-/g, '+').replace(/_/g, '/'))
  return Uint8Array.from([...raw].map((c) => c.charCodeAt(0)))
}

export function pushAvailable(): boolean {
  return 'serviceWorker' in navigator && 'PushManager' in window && 'Notification' in window
}

export async function currentPushSubscription(): Promise<PushSubscription | null> {
  if (!pushAvailable()) return null
  const registration = await navigator.serviceWorker.getRegistration('/support-sw.js')
  return registration ? registration.pushManager.getSubscription() : null
}

export async function enablePushOnDevice(authFetch: AuthFetch, api: string): Promise<void> {
  if (!pushAvailable()) throw new Error('Push notifications are not supported in this browser.')
  const configResponse = await authFetch(`${api}/api/v1/settings/push/config`)
  const config = (await configResponse.json()).data
  if (!configResponse.ok || !config?.configured || !config.public_key) throw new Error('Push notifications are not configured.')
  const permission = await Notification.requestPermission()
  if (permission !== 'granted') throw new Error('Notification permission was not granted.')
  const registration = await navigator.serviceWorker.register('/support-sw.js')
  const existing = await registration.pushManager.getSubscription()
  const subscription = existing ?? await registration.pushManager.subscribe({
    userVisibleOnly: true,
    applicationServerKey: base64Bytes(config.public_key) as BufferSource,
  })
  const response = await authFetch(`${api}/api/v1/settings/push/subscribe`, {
    method: 'POST',
    body: JSON.stringify({ ...subscription.toJSON(), user_agent: navigator.userAgent }),
  })
  if (!response.ok) throw new Error((await response.json()).error || 'This device could not be enrolled.')
}
